import { SortItemType } from '../../../hooks/useSort';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { TrackingService } from 'service/tracking/trackingService';

const SearchCategorySelectorComp = dynamic(
  () => import('components/SearchCategorySelector').then((m: any) => m.SearchCategorySelector),
  { ssr: true },
) as any;

type Props = {
  searchCategories: Record<string, string>;
  currentSearchCategory: string;
  query: string;
  onSelect: (category: string, sortType: SortItemType) => void;
};

const SearchCategorySelector: FC<Props> = ({
  searchCategories,
  currentSearchCategory,
  query,
  onSelect,
}) => {
  const router = useRouter();

  const searchCategoryClick = (currentCategory: string, targetCategory: string) => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    router.push(
      `?category=${encodeURIComponent(targetCategory.toLowerCase())}${
        query ? `&query=${encodeURIComponent(query)}` : ''
      }`,
    );
    TrackingService.searchCategoryChange(currentCategory, targetCategory);
  };

  const getSortItemType = (searchCategory: string): SortItemType => {
    if (searchCategory === searchCategories.ALL) return SortItemType.ANY;
    if (searchCategory === searchCategories.RECIPES) return SortItemType.RECIPE_SEARCH_RESULT;
    if (searchCategory === searchCategories.PRODUCTS) return SortItemType.PRODUCT_SEARCH_RESULT;
    if (searchCategory === searchCategories.TIPS) return SortItemType.TIPS_AND_TRICKS_SEARCH_RESULT;
    if (searchCategory === searchCategories.ARTICLES) return SortItemType.ARTICLES_SEARCH_RESULT;
    return SortItemType.ANY;
  };

  const handleCategorySelect = (category: string) => {
    const sortType = getSortItemType(searchCategories[category]);
    searchCategoryClick(currentSearchCategory, category);
    onSelect(category, sortType);
  };
  return (
    <SearchCategorySelectorComp
      id="sort-controls"
      categories={searchCategories}
      selected={currentSearchCategory}
      onSelect={handleCategorySelect}
    />
  );
};

export default SearchCategorySelector;
